import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { configQuery } from '../../utils/config-query';
import { IResponse } from '../../utils/interfaces/response';
import {
  IUnit,
  IUnitList,
  IUnitSuspiciousActivityConfig,
  IUnitUpdatePayload,
} from '../../utils/interfaces/unit';

@Injectable({
  providedIn: 'root',
})
export class UnitsService {
  private readonly URI_API = environment.apiConfig.uri + 'Branch';

  constructor(private readonly httpClient: HttpClient) {}

  getUnitsFilter(
    search: boolean,
    searchString: string = '',
    page: number = 1,
    take: number = 0,
    status: boolean | null = null
  ): Observable<IResponse<IUnitList[]>> {
    return this.httpClient.get<IResponse<IUnitList[]>>(
      `${this.URI_API}/filter${configQuery(
        search,
        searchString,
        page,
        take,
        status
      )}`
    );
  }

  getUnitById(id: string): Observable<IResponse<IUnit>> {
    return this.httpClient.get<IResponse<IUnit>>(`${this.URI_API}/${id}`);
  }

  getSuspiciousActivityConfig(
    branchId: string
  ): Observable<IResponse<IUnitSuspiciousActivityConfig | null>> {
    return this.httpClient.get<IResponse<IUnitSuspiciousActivityConfig | null>>(
      `${this.URI_API}/${branchId}/suspicious-activity-config`
    );
  }

  getUnitUserPollById(id: string): Observable<IResponse<IUnit>> {
    return this.httpClient.get<IResponse<IUnit>>(
      `${this.URI_API}/user-poll/?pollId=${id}`
    );
  }

  getUnitsWithAccess(
    searchString: string,
    search: boolean = true,
    page: number = 1,
    take: number = 1000000,
    status: boolean | null = null
  ): Observable<IResponse<IUnitList[]>> {
    return this.httpClient.get<IResponse<IUnitList[]>>(
      `${this.URI_API}/with-access${configQuery(
        search,
        searchString,
        page,
        take,
        status
      )}`
    );
  }

  updateUnit(unit: IUnitUpdatePayload): Observable<IResponse<IUnit>> {
    return this.httpClient.put<IResponse<IUnit>>(
      `${this.URI_API}/update`,
      unit
    );
  }

  updateSuspiciousActivityConfig(
    branchId: string,
    suspiciousActivityConfig: IUnitSuspiciousActivityConfig
  ): Observable<IResponse<unknown>> {
    return this.httpClient.put<IResponse<unknown>>(
      `${this.URI_API}/${branchId}/suspicious-activity-config`,
      suspiciousActivityConfig
    );
  }

  refreshShortBranch(id: string): Observable<IResponse<boolean>> {
    return this.httpClient.patch<IResponse<boolean>>(
      `${this.URI_API}/refresh-short-branch?branchId=${id}`,
      {}
    );
  }
}
